const {h, render, Component} = require('preact');

class ButtonView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div data-bhw="web2018_email_ticket_submit" >
        <input className={this.props.inputClass} type="button" onClick={this.props.onButtonClick}
               value={this.props.buttonText}/>
      </div>
    )
  }
}

module.exports = ButtonView
